import React, { Component } from "react";
import { hot } from "react-hot-loader";
import { connect } from "react-redux";
import { Divider } from "@material-ui/core";
import TableList from "../../Utilities/Helpers/TableList/TableList";
import { StyledCard, StyledContent, StyledHeader } from "../../styles";
import {
    Update as StatusIcon,
    List as ListIcon,
    LocationOn as MapIcon,
    Today as TodayIcon,
} from "@material-ui/icons";

import {
    getJobPacks,
    setDateFrom,
    setDateTo,
    setSearchVal,
    setFilterVal,
    getJobPacksModals,
    postUpdatedStatus,
    setViewType,
    setModalOpen,
    setPageIndex,
    redirectTo,
    getDepartments,
    getAreas,
    setCurrentTable,
    setJobMonth,
    removeJobPack,
    setJobYear,
    getJobPacksDefault,
    getJobPacks2,
    getJobPacks2Default,
    setSortTableAs,
    setStatus,
    setClickedStatusJobID,
    setDayFrom,
    archieveJobs,
    setSortTableType,
    setSortTableKey,
    getJobPackTemplates,
    setTemplate,
    setAreasDept,
    setJobUrn
} from "./actions";
import { initialise } from "./RosterV2/actions";
import {
    selectDateFrom,
    selectDateTo,
    selectFilterStatus,
    selectDepartmentStatus,
    selectAreaStatus,
    selectSearchVal,
    selectRowCount,
    selectPaginatedJobpacks,
    selectPageIndex,
    selectFilteredJobpacks,
    getRequesting,
    selectPermissions,
    selectSortTableKey,
    selectSortTableType,
    selectAreas,
    selectDepartments,
    selectViewType,
    selectCurrentTable,
    selectJobMonth,
    selectJobYear,
    selectMapKey,
    selectAllJobpacksArray2,
    selectAllJobPacks3,
    selectDayFrom,
    selectArchieveJobList,
    selectTemplates,
    selectTemplate,
    selectAreasDept,
    selectJobURN
} from "./selectors";
import { JobPackControls } from "./JobPackControls";
import styled from "styled-components";
import JobPackModal from "./JobPackModal";
import { JobPackMapView } from "./JobPackMapView";
import PostStatusSnackbar from "./PostStatusSnackbar";
import Roster from "./RosterV2/RosterV2";
import { Route } from "react-router-dom";
import { Modal, ModalBody, Spinner, ModalFooter, Col, Row } from "reactstrap";
import {
    Typography,
    Tabs,
    Tab,
    withWidth,
    IconButton,
    Button,
    Tooltip,
    Switch,
} from "@material-ui/core";
import moment from "moment";
import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";
import { jobpackTableConfig } from "./jobpackTableConfig";

const ModalRow = styled(Row)`
    margin-bottom: 10px;
`;
const TabsBar = styled(Tabs)`
    border: 0px solid black;
    width: fit-content;
    border-radius: 5px;
    background-color: white;
`;

class JobPackManager extends Component {
    constructor(props) {
        super(props);
        let year = moment().format("YYYY");

        let month = moment().format("MMM").toLowerCase();
        this.state = {
            status: "active",
            view: props.location.pathname.split("/"),
            warning1: false,
            warning2: false,
            yearReference: moment().format("YYYY"),
            monthReference: moment().format("MMM").toLowerCase(),
            id: "",
            tstamp: "",
            st: "active",
            name: ""
        };
        this.props.setViewType("list");
        props.getJobPacksDefault("active", year, month);
        props.getDepartments();
        props.getAreas();
        props.getJobPackTemplates();
        // props.archieveJobs(this.props.jobref)
        this.props.getJobPacks2Default("active", year);
        this.props.initialise(
            props.match.params.startDate,
            props.match.params.weekCount
        );
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.match.params.startDate !==
                this.props.match.params.startDate ||
            prevProps.match.params.weekCount !==
                this.props.match.params.weekCount
        ) {
            this.props.initialise(
                this.props.match.params.startDate,
                this.props.match.params.weekCount
            );
        }

        if (
            prevProps.filteredJobpacks.length !==
            this.props.filteredJobpacks.length
        ) {
            const { rowCount, pageIndex } = this.props;
            const { length } = this.props.filteredJobpacks;

            if (rowCount * pageIndex > length) {
                this.props.setPageIndex(0);
            }
        }

        if (prevProps.archieveJobList !== this.props.archieveJobList) {
            this.autoArchieve(this.props.archieveJobList);
        }
    }

    autoArchieve(jobref) {
        this.props.archieveJobs(jobref);
    }

    handleStatusChange = (tabStatus, year, month, getJobPacks) => {
        getJobPacks(tabStatus, year, month);
        getJobPacks2(tabStatus, year, month);
        this.setState({
            status: tabStatus,
        });
    };

    render() {
        const { currentTable, year, month, viewType, redirectTo,toggleAreasDept } = this.props;
        
        return (
            <>
                <StyledCard>
                    <StyledHeader>
                        <Typography variant="h5">
                            Jobpack Manager 
                            <div style={{ float: "right" }}>
                                <IconButton
                                    value="map"
                                    variant="contained"
                                    style={{
                                        color:
                                            viewType === "map"
                                                ? "#0188cc"
                                                : "default",
                                        border:
                                            viewType === "map"
                                                ? "1px solid #0188cc"
                                                : "0px",
                                    }}
                                    onClick={(e) => {
                                        this.props.setViewType("map");
                                        redirectTo("/job-pack-manager/map");
                                    }}
                                >
                                    <MapIcon />
                                </IconButton>
                                <IconButton
                                    value="list"
                                    variant="contained"
                                    style={{
                                        color:
                                            viewType === "list"
                                                ? "#0188cc"
                                                : "default",
                                        border:
                                            viewType === "list"
                                                ? "1px solid #0188cc"
                                                : "0px",
                                    }}
                                    onClick={(e) => {
                                        this.props.setViewType("list");
                                        redirectTo("/job-pack-manager/list");
                                    }}
                                >
                                    <ListIcon />
                                </IconButton>
                                <IconButton
                                    value="roster"
                                    variant="contained"
                                    style={{
                                        color:
                                            viewType === "roster"
                                                ? "#0188cc"
                                                : "default",
                                        border:
                                            viewType === "roster"
                                                ? "1px solid #0188cc"
                                                : "0px",
                                    }}
                                    onClick={(e) => {
                                        this.props.setViewType("roster");
                                        redirectTo(
                                            "/job-pack-manager/roster/today"
                                        );
                                        this.props.setDateFrom();
                                        this.props.setDateTo();
                                    }}
                                >
                                    <TodayIcon />
                                </IconButton>
                            </div>
                        </Typography>
                    </StyledHeader>
                    <StyledContent>
                        <Modal
                            isOpen={this.props.requesting}
                            style={{ maxWidth: "00px" }}
                        >
                            <ModalBody>
                                <div
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "3em",
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "white",
                                            width: "fit-content",
                                            display: "inline-block",
                                            padding: "2em",
                                        }}
                                    >
                                        <Spinner
                                            style={{
                                                height: 100,
                                                width: 100,
                                                background: "white",
                                            }}
                                            color="primary"
                                        />
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                marginTop: 15,
                                                color: "rgba(0, 0, 0, 0.87)",
                                                fontWeight: "bolder",
                                                fontSize: 20,
                                            }}
                                            variant="body2"
                                        >
                                            Processing...
                                        </Typography>
                                    </div>
                                </div>
                            </ModalBody>
                        </Modal>

                        <JobPackControls
                            {...this.props}
                            status={this.state.status}
                            redirectTo={this.props.redirectTo}
                            isPermitted={this.props.permissions.create || true}
                        />
                        <Divider />
                        <div style={{float:"right"}}>
                        <Typography>{toggleAreasDept ? 'Hide' : 'Show'} Areas & Departments</Typography>
                        <Switch
                            checked={toggleAreasDept}
                            onChange={(event, value) => {
                                this.props.setAreasDept(!toggleAreasDept)
                            }}
                            style={{color:"#0188cc"}}
                            name="checkedB"
                            inputProps={{ 'aria-label': 'primary checkbox' }}
                        />
                        </div>
                        <TabsBar
                            value={currentTable}
                            onChange={(event, value) => {
                                this.setState({
                                    status: value,
                                });
                                this.props.setStatus(value);
                                this.props.setFilterVal(value);
                                this.props.setCurrentTable(value);
                                this.props.getJobPacks(value, year, month);
                                this.props.getJobPacks2(value, year, month);
                            }}
                            indicatorColor="primary"
                            textColor="primary"
                        >
                            <Tab
                                value="active"
                                label={
                                    <span style={{ color: "green" }}>
                                        Active
                                    </span>
                                }
                            />
                            <Tab
                                disabled={this.state.view[3] === "today"}
                                value="pending"
                                label={
                                    <span style={{ color: "orange" }}>
                                        Pending
                                    </span>
                                }
                            />
                            <Tab
                                disabled={this.state.view[3] === "today"}
                                value="archived"
                                label={
                                    <span style={{ color: "red" }}>
                                        Archived
                                    </span>
                                }
                            />
                        </TabsBar>
                        <Route
                            exact
                            path="/job-pack-manager/list"
                            component={() => (
                                <TableList
                                    width={this.props.width}
                                    listData={this.props.paginatedJobpacks}
                                    filteredJobpacks={
                                        this.props.filteredJobpacks
                                    }
                                    enableSorting
                                    tableConfig={toggleAreasDept ? jobpackTableConfig : this.props.tableConfig}
                                    permissions={this.props.permissions}
                                    st={this.props.currentTable}
                                    setSortTableType={
                                        this.props.setSortTableType
                                    }
                                    setSortTableAs={this.props.setSortTableAs}
                                    setSortTableKey={this.props.setSortTableKey}
                                    sortTableKey={this.props.sortTableKey}
                                    sortTableType={this.props.sortTableType}
                                    year={year}
                                    isReports={false}
                                    deleteAction={(data) => {
                                        
                                        this.setState({
                                            warning1: true,
                                            id: data.job_id,
                                            name: data.job_name,
                                            tstamp: data.timestamp,
                                            yearReference: moment(
                                                data.timestamp,
                                                "DD-MM-YYYY HH:mm:ss"
                                            ).format("YYYY"),
                                            st: data.status,
                                            monthReference: moment(
                                                data.timestamp,
                                                "DD-MM-YYYY HH:mm:ss"
                                            )
                                                .format("MMM")
                                                .toLowerCase(),
                                        });
                                    }}
                                    month={month}
                                    selectActionData={(data, actType) => {
                                        if (actType === "status" && data) {
                                            if (this.props.permissions.update) {
                                                let mon = moment(
                                                    data.timestamp,
                                                    "DD-MM-YYYY HH:mm:ss"
                                                )
                                                    .format("MMM")
                                                    .toLowerCase();
                                                let year = moment(
                                                    data.timestamp,
                                                    "DD-MM-YYYY HH:mm:ss"
                                                ).format("YYYY");
                                                this.props.setClickedStatusJobID(
                                                    data.job_id
                                                );
                                                this.props.getJobPacksModals(
                                                    data.status,
                                                    year,
                                                    mon
                                                );

                                                this.props.setModalOpen(true);
                                            }
                                        }
                                    }}
                                    customActions={{ 
                                        status: (
                                            <Tooltip title="Move Jobpack">
                                                <span>
                                                    <StatusIcon />
                                                </span>
                                            </Tooltip>
                                        ) }}
                                    customCellKeys={["urn"]}
                                    customCells={(data, cellKey) => {
                                        if (cellKey === "urn") {
                                            return (
                                                <>
                                                <Tooltip title={data[cellKey]}>
                                                    <Typography
                                                        onClick={() => {}}
                                                        style={{
                                                            marginLeft:"-10px",
                                                            cursor: "pointer",
                                                            fontSize:"13px",
                                                            color: "black",
                                                        }}
                                                    >
                                                        {data[cellKey]}
                                                    </Typography>
                                                    </Tooltip>
                                                </>
                                            );
                                        }
                                    }}
                                    // customCellKeys={["address"]}
                                    // customCells={(data, cellKey) => {
                                    //     if (cellKey === "address") {
                                    //         return (
                                    //             <>
                                    //                 <Typography
                                    //                     onClick={() => {}}
                                    //                     style={{
                                    //                         marginLeft: -26,
                                    //                         padding: 44,
                                    //                         cursor: "pointer",
                                    //                         textAlign: "left",
                                    //                         color: "red",
                                    //                     }}
                                    //                 >
                                    //                     {data[cellKey]}
                                    //                 </Typography>
                                    //             </>
                                    //         );
                                    //     }
                                    // }}
                                />
                            )}
                        />

                        <Route
                            exact
                            path="/job-pack-manager/map"
                            component={() => (
                                <JobPackMapView
                                    jobPacks={this.props.filteredJobpacks}
                                    redirectTo={this.props.redirectTo}
                                    permissions={this.props.permissions}
                                    st={this.props.currentTable}
                                    year={year}
                                    month={month}
                                    mapKey={this.props.mapKey}
                                />
                            )}
                        />

                        <Route
                            exact
                            path="/job-pack-manager/roster/today"
                            component={Roster}
                        />
                        <Route
                            exact
                            path="/job-pack-manager/roster/date/:startDate/:weekcount"
                            component={Roster}
                        />
                    </StyledContent>
                </StyledCard>
                <Modal
                    isOpen={this.state.warning1}
                    backdropTransition={{
                        timeout: 1300000000,
                    }}
                >
                    <StyledHeader>
                        <Typography
                            variant="h5"
                            style={{
                                color: "red",
                            }}
                        >
                            Warning!!!
                        </Typography>
                    </StyledHeader>
                    <StyledContent>
                        <ModalBody>
                            <ModalRow>
                                <Col>
                                    <Typography>
                                        <b>
                                            You are about to delete{" "}
                                            {this.state.id}
                                        </b>
                                    </Typography>
                                    <br />
                                    <Typography>
                                        This action is permanent and cannot be
                                        undone. once deleted, any content linked
                                        to the user, such as sales history and
                                        reports, will be displayed with the
                                        following
                                    </Typography>
                                </Col>
                            </ModalRow>
                        </ModalBody>
                    </StyledContent>
                    <ModalFooter>
                        <div>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                    backgroundColor: "#0288CC",
                                    color: "white",
                                }}
                                onClick={() => {
                                    this.setState({
                                        warning1: false,
                                        id: "",
                                        tstamp: "",
                                    });
                                }}
                            >
                                Don't Delete
                            </Button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button
                                variant="contained"
                                color="danger"
                                style={{
                                    backgroundColor: "#ce3939",
                                    color: "white",
                                }}
                                onClick={() => {
                                    this.setState({
                                        warning1: false,
                                        warning2: true,
                                    });
                                }}
                            >
                                Delete
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
                <Modal
                    isOpen={this.state.warning2}
                    backdropTransition={{
                        timeout: 1300000000,
                    }}
                >
                    <StyledHeader>
                        <Typography
                            variant="h5"
                            style={{
                                color: "red",
                            }}
                        >
                            Confirm Delete!!!
                        </Typography>
                    </StyledHeader>
                    <StyledContent>
                        <ModalBody>
                            <ModalRow>
                                <Col>
                                    <Typography>
                                        <b>
                                            You are about to delete{" "}
                                            {this.state.id}
                                        </b>
                                    </Typography>
                                    <br />
                                    <Typography>
                                        Please confirm the Delete?
                                    </Typography>
                                </Col>
                            </ModalRow>
                        </ModalBody>
                    </StyledContent>
                    <ModalFooter>
                        <div>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                    backgroundColor: "#0288CC",
                                    color: "white",
                                }}
                                onClick={() => {
                                    this.setState({
                                        warning1: false,
                                        warning2: false,
                                        id: "",
                                        tstamp: "",
                                    });
                                    let name = 'N/A';
                                    if(this.state.name){
                                        name = this.state.name;
                                    }
                                    let reference = name + '-' + this.state.id
                                    this.props.setActivity('delete','jobpack',reference)
                                    this.props.removeJobPack(
                                        this.state.id,
                                        this.state.st,
                                        this.state.yearReference,
                                        this.state.monthReference,
                                        this.state.tstamp
                                    );
                                }}
                            >
                                Confirm
                            </Button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button
                                variant="contained"
                                color="danger"
                                style={{
                                    backgroundColor: "#ce3939",
                                    color: "white",
                                }}
                                onClick={() => {
                                    this.setState({
                                        warning1: false,
                                        warning2: false,
                                        id: "",
                                        tstamp: "",
                                    });
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
                <JobPackModal year={year} month={month} />
                <PostStatusSnackbar />
            </>
        );
    }
}

export default hot(module)(
    connect(
        (store) => {
            return {
                dateFrom: selectDateFrom(store),
                dateTo: selectDateTo(store),
                filterStatus: selectFilterStatus(store),
                departmentStatus: selectDepartmentStatus(store),
                areaStatus: selectAreaStatus(store),
                searchVal: selectSearchVal(store),
                rowCount: selectRowCount(store),
                pageIndex: selectPageIndex(store),
                filteredJobpacks: selectFilteredJobpacks(store),
                paginatedJobpacks: selectPaginatedJobpacks(store),
                requesting: getRequesting(store),
                permissions: selectPermissions(store),
                departments: selectDepartments(store),
                areas: selectAreas(store),
                currentTable: selectCurrentTable(store),
                month: selectJobMonth(store),
                sortTableKey: selectSortTableKey(store),
                sortTableType: selectSortTableType(store),
                year: selectJobYear(store),
                mapKey: selectMapKey(store),
                viewType: selectViewType(store),
                jobpacks2: selectAllJobpacksArray2(store),
                jp3: selectAllJobPacks3(store),
                day: selectDayFrom(store),
                archieveJobList: selectArchieveJobList(store),
                templates: selectTemplates(store),
                template:selectTemplate(store),
                toggleAreasDept: selectAreasDept(store),
                jobURN: selectJobURN(store)
            };
        },
        {
            getJobPacks,
            setDateFrom,
            setDateTo,
            setSearchVal,
            setDayFrom,
            setFilterVal,
            setSortTableKey,
            setSortTableType,
            setJobMonth,
            setJobYear,
            postUpdatedStatus,
            setSortTableAs,
            redirectTo,
            initialise,
            setPageIndex,
            setViewType,
            removeJobPack,
            getDepartments,
            getAreas,
            setCurrentTable,
            getJobPacksDefault,
            getJobPacks2,
            getJobPacksModals,
            getJobPacks2Default,
            setModalOpen,
            setStatus,
            setClickedStatusJobID,
            archieveJobs,
            getJobPackTemplates,
            setTemplate,
            setActivity,
            setAreasDept,
            setJobUrn
        }
    )(withWidth()(JobPackManager))
);
